import { useState, useEffect } from "react";
import FormData from "form-data";
import axios from "axios";
import * as ReactBootStrap from "react-bootstrap";


function Read() {
  const [cardData, setCardData] = useState({
    status: "",
    request_id: "",
    
    
 
  });
  const [img, setImg] = useState();
  const [loading , setLoading] = useState(true)


  useEffect(() => { 
    console.log(cardData);
  }, [cardData]);

  const onChange = (e) => {
    var file = e.target.files[0];
    let base64String = "";

    var reader = new FileReader();
    console.log("next");

    reader.onload = function () {
      base64String = reader.result.replace("data:", "").replace(/^.+,/, "");
      console.log("base64String", base64String);
      setImg("b " + base64String);
    };
    reader.readAsDataURL(file);
  };

  const submit = () => {
    setLoading(false);
    setCardData({
        status: "",
        request_id: "",
      
    });
    var data = new FormData();
    data.append("ImageByte", img);
    var config = {
      method: "post",
      url: "https://cba4wuuvuk.execute-api.ap-south-1.amazonaws.com/default/DOCUMENT_READABILITY?REQUEST_ID=AinxtRequest",
      headers: {
        "x-api-key": "dcX7EVfGfp7AY6aecMZLd6h1cwjg9t5p4grJMdPr",
        authorizationToken: "6t1d929B9Rf0hLPJ",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        
        console.log(JSON.stringify(response.data));
        setCardData(response.data);
        setLoading(true);
      })
      .catch(function (error) {
        setLoading(true)
        alert("Something went wrong with server");
        console.log(error);
      });
  };

  useEffect(() => {}, [cardData]);

  return (
    <div>
      <div>
        <div class="container containerBoreder " id="pan">
          <h2 class="pageTitle">Document Quality Check</h2>
          <div class="row">
            <div class="col-4">
              <input type="file" onChange={onChange} />
            </div>
            {loading?(<div class="col-4">
              <button class="btn btn-primary" onClick={submit}>
                Submit
              </button>
            </div>) :<ReactBootStrap.Spinner animation="border" />}
          </div>
          <br />
          <table class="table">
            <tbody>
              <tr>
                <th width="25%">Status Type</th>
                <td>{cardData.status}</td>
              </tr>
              <tr>
                <th>Request ID</th>
                <td>{cardData.request_id} </td>
              </tr>
             
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Read;
